// LICENSE_CODE ZON
'use strict'; /*jslint react:true*/
import React from 'react';
import {Text} from '../../comp/text';
import store from '../../store.js';
import {fmt_money} from '../../utils/misc.js';
import {Referees_bvpn_table} from './table_bvpn.js';
import * as cns from './shared.module.less';

function Metric({name, value}){
    return <li className={cns.metric}>
      <Text.s>
        {name}: <Text.m span mono bold>{value}</Text.m>
      </Text.s>
    </li>;
}

export function Connected_bvpn(){
    const [{list, invited, accepted, earned, bounty},, loading, pagination] =
        store.use_referees_bvpn();
    return <div>
      <div>
        <Text.xxl h2>My Bright VPN Referrals</Text.xxl>
        <ul className={cns.list}>
          <Metric name="Invited" value={invited||0}/>
          <Metric name="Accepted" value={accepted||0}/>
          <Metric name="Redeemed" value={earned||0}/>
          <Metric name="Lifetime earning" value={fmt_money(bounty)}/>
        </ul>
      </div>
      <Referees_bvpn_table list={list} loading={loading}
        pagination={pagination}/>
    </div>;
}
